import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { useMilestone } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { DEPRECATED_RESTART_WHEN_ISPAGELOADING_BECOMES_TRUE, useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { HAS_VISITED_CATEGORY_SEARCH_PAGES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_VISITED_CATEGORY_SEARCH_PAGES";
import { observer } from "mobx-react";
import React, { useEffect, useLayoutEffect } from "react";
import { PageLoadEvent } from "@faire/retailer/services/performance/const";
import { PerformanceMarker } from "@faire/retailer/services/performance/PerformanceMarker";
import { LoggedOutCategoryPageFilterStoreProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/LoggedOutCategoryPageFilterStoreProvider";
import { LoggedOutCategoryPageCurrentCategoryProvider, useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { LoggedOutCategoryPageCurrentNavigationPathProvider } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { useLoggedOutCategoryPageFilterSections } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageFilterSections";
import { useLoggedOutCategoryPageisLoadedAndHasNoResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageisLoadedAndHasNoResults";
import { LoggedOutCategoryPageBase } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/LoggedOutCategoryPageBase";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
var InternalLoggedOutCategoryPage = function() {
    var category = useLoggedOutCategoryPageCurrentCategory();
    var _useLoggedOutCategoryPageCatNavResponse = useLoggedOutCategoryPageCatNavResponse(), isCatNavFetching = _useLoggedOutCategoryPageCatNavResponse.isFetching, dataUpdatedAt = _useLoggedOutCategoryPageCatNavResponse.dataUpdatedAt, error = _useLoggedOutCategoryPageCatNavResponse.error;
    var _useLoggedOutCategoryPageFilterSections = useLoggedOutCategoryPageFilterSections(), isFiltersFetching = _useLoggedOutCategoryPageFilterSections.isFetching;
    var isLoading = isCatNavFetching || isFiltersFetching;
    var isLoadedAndHasNoResults = useLoggedOutCategoryPageisLoadedAndHasNoResults();
    var _useMilestone = useMilestone(HAS_VISITED_CATEGORY_SEARCH_PAGES), setHasVisitedCategorySearchPages = _useMilestone.setHasOccurred;
    useEffect(function() {
        PerformanceMarker.get().mark(PageLoadEvent.pageStart);
    }, []);
    useEffect(function() {
        setHasVisitedCategorySearchPages();
    }, [
        setHasVisitedCategorySearchPages
    ]);
    useLayoutEffect(function() {
        if (!isLoading) {
            PageInitialized.publish();
        }
    }, [
        isLoading
    ]);
    var pageName = "page-category-product-logged-out";
    var loadTimingRef = useUserPerceivedLoadTimingWithKey({
        name: pageName,
        pageLoadKey: DEPRECATED_RESTART_WHEN_ISPAGELOADING_BECOMES_TRUE,
        dataUpdatedAt: dataUpdatedAt,
        numComponents: 1,
        ignoreImages: isLoadedAndHasNoResults || !!error,
        isPageLoading: isLoading,
        pageJsExecutedMark: PAGE_JS_EXECUTED_MARK,
        enableTrackPerformanceBreakdown: "internal-tracking"
    });
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    var pageType = pathname.includes("/suppliers") ? "suppliers" : "category";
    var _category_urlIdStrings = _sliced_to_array(category.urlIdStrings, 3), c1 = _category_urlIdStrings[0], c2 = _category_urlIdStrings[1], c3 = _category_urlIdStrings[2];
    useEffect(function() {
        trackRetailersPageViewView("", "", "", pageType, pathname, pageName, c1 !== null && c1 !== void 0 ? c1 : "", c2 !== null && c2 !== void 0 ? c2 : "", c3 !== null && c3 !== void 0 ? c3 : "");
    }, [
        pageType,
        pathname,
        pageName,
        c1,
        c2,
        c3
    ]);
    return /*#__PURE__*/ _jsx(LoggedOutCategoryPageBase, {
        categoryPageLoadTimingRef: isLoading ? undefined : loadTimingRef
    });
};
export var InternalLoggedOutCategoryPageObserver = observer(InternalLoggedOutCategoryPage);
export var LoggedOutCategoryPage = function(param) {
    var category = param.category, navigationPath = param.navigationPath;
    return /*#__PURE__*/ _jsx(LoggedOutCategoryPageCurrentCategoryProvider, {
        value: category,
        children: /*#__PURE__*/ _jsx(LoggedOutCategoryPageCurrentNavigationPathProvider, {
            value: navigationPath,
            children: /*#__PURE__*/ _jsx(LoggedOutCategoryPageFilterStoreProvider, {
                children: /*#__PURE__*/ _jsx(InternalLoggedOutCategoryPageObserver, {})
            })
        })
    });
};
